import React, {createContext, useContext} from 'react';

export type ListValue = string | number;

export type ListSelectMode = 'single' | 'multiple';

export type ListSelectAppearance = 'selected' | 'checkbox' | 'line';

export type ListNavigationMode = 'items' | 'composite';

export type ListController = {
	/** индекс активного пункта или null, если активного нет */
	activeIndex(): number | null;
	/** сдвигает активный пункт; из «нет активного» вниз — на первый */
	move(delta: 1 | -1): void;
	first(): void;
	last(): void;
	clear(): void;
	/** нажимает активный пункт; false, если активного нет */
	activate(): boolean;
	/** настоящий фокус на пункт; без индекса — на выбранный или первый */
	focus(index?: number): void;
};

export type ListContextValue = {
	selectMode?: ListSelectMode;
	selectAppearance: ListSelectAppearance;
	navigationMode?: ListNavigationMode;
	virtualFocus?: boolean;
	virtual?: boolean;
	horizontal?: boolean;
	itemTag: 'li' | 'div';
	itemRole?: React.AriaRole;
	isSelected(value?: ListValue): boolean;
	toggle(value: ListValue | undefined, event: React.SyntheticEvent): void;
	itemAction(value: ListValue | undefined, index: number, event: React.SyntheticEvent): void;
	activeIndex: number | null;
	/** активный пункт выбран с клавиатуры: подсвечиваем его как фокус */
	activeFocusVisible: boolean;
	setActiveIndex(index: number | null, focusVisible?: boolean): void;
	idFor(index: number): string;
	indexOf(element: HTMLElement | null): number;
	size(): number;
};

export const ListContext = createContext<ListContextValue | null>(null);

export const useListContext = () => useContext(ListContext);

/** порядковый номер пункта в списке с учётом групп; -1 — пункт отрисован вне списка */
export const ListItemIndexContext = createContext(-1);

/** ref для измерения строки виртуального списка */
export const ListRowRefContext = createContext<((element: HTMLElement | null) => void) | null>(null);

export const LIST_ITEM_ATTR = 'data-list-item';

/**
 * Управление, которое выпадашка отдаёт спискам внутри себя: стрелки в поле ввода двигают пункт списка.
 * Список прямо в выпадашке получает его пропсами, а список внутри своего компонента — отсюда.
 */
export type ListWiring = {
	navigationMode?: ListNavigationMode;
	virtualFocus?: boolean;
	controllerRef?: React.Ref<ListController>;
	onActiveChange?(id: string | undefined, value: ListValue | undefined, index: number | null): void;
};

export const ListWiringContext = createContext<ListWiring | null>(null);
